import type React from 'react';

import {IS_MAC} from '~ui/constants';

type CombinedKeyboardEvent = KeyboardEvent | React.KeyboardEvent;

const hasModKey = (event: CombinedKeyboardEvent) => (IS_MAC ? event.metaKey : event.ctrlKey);
const hasShift = (event: CombinedKeyboardEvent) => event.shiftKey;
const hasAlt = (event: CombinedKeyboardEvent) => event.altKey;

export const isSaveKey = (event: CombinedKeyboardEvent) => {
    return event.code === 'KeyS' && hasModKey(event);
};

export const isWikiSearchShortcut = (event: CombinedKeyboardEvent) => {
    return event.code === 'KeyS' && IS_MAC ? event.ctrlKey : event.altKey;
};

export const isGridSearchShortcut = (event: CombinedKeyboardEvent) => {
    return hasShift(event) && hasModKey(event) && event.code === 'KeyF' && !hasAlt(event);
};

export const isPageSearchShortcut = (event: CombinedKeyboardEvent) => {
    return hasModKey(event) && event.code === 'KeyF' && !hasAlt(event) && !hasShift(event);
};

export const isFormSubmit = (event: CombinedKeyboardEvent) => {
    return event.code === 'Enter' && hasModKey(event);
};

export const isFormCancel = (event: CombinedKeyboardEvent) => {
    return event.code === 'Escape';
};
